import $ from 'jquery';



var headerSearchbtn;
var headerSearchInput;

var formSearch;
var formSearchInput;
var formSearchBtn;
var formResultsCount;
var formLoadMoreBtn;
var sResults;
var pIndex = 0;

$(document).ready(function(){
	headerSearchbtn = $("header .search-box__button");
	headerSearchInput = $("header .search-box__input")

	headerSearchbtn.on("click",headerSearchClick);
	headerSearchInput.on("keydown",headerKeyHandler);

	formSearch = $(".search-form");

	if(formSearch.length == 0){
		return;
	}

	formSearchBtn = formSearch.find(".search-btn");
	formSearchInput = formSearch.find(".search-txt");

	formResultsCount = formSearch.find(".page-search-results-count");
	formLoadMoreBtn = formSearch.find(".loadmore-btn");


	formLoadMoreBtn.on("click",formLoadMoreClick);


	formSearchBtn.on("click",formSearchClick);
	formSearchInput.on("keydown",keyHandler)
	sResults = formSearch.find(".page-search-results");

	if(formSearchInput.val() != ""){
		runSearch();
	}

});

function headerKeyHandler(event){
	if(event.keyCode == 13){
		event.preventDefault();	
		headerSearchClick();
	}	
}


function headerSearchClick(event){
	if(event != undefined){
		event.preventDefault();
	}

	var sVal = headerSearchInput.val();
	console.log(headerSearchInput,"headerSearchClick");
	if(sVal == ""){
		sVal = headerSearchInput.eq(1).val();
	}
	var url =  window.location.protocol +"//"+ window.location.host + headerSearchbtn.attr("data-searchpage") + "/?s=" + sVal;	
	window.location.href = url;	
}


function keyHandler(event){
	if(event.keyCode == 13){
		event.preventDefault();	
		runSearch(event);
	}
}
function formLoadMoreClick(event){
	pIndex ++;
	//sResults.html("");
	event.preventDefault();	
	runSearch();
}
function formSearchClick(event){
	pIndex = 0;
	sResults.html("");
	event.preventDefault();	
	runSearch();
}

function runSearch(){

	formLoadMoreBtn.addClass("hidden");
	

	
	var val = formSearchInput.val();
	var url = formSearchInput.attr("data-search-api") + val;
	

	var data = {};
	data.id = val;
	data.pageIndex = pIndex;
	data.timestamp = new Date().getTime();

	
	//sResults.html("")

	$.ajax({
		dataType: "json",
		url:url,
		data:data,
		method:"GET",
		success:onSearchData

	});
}

function onSearchData(results){
	console.log(results);

	if(results.HasMoreResults){
		formLoadMoreBtn.removeClass("hidden");
	}
	formResultsCount.html(results.TotalResults);

	if(results.Items.length == 0){
		
	}

	var items = results.Items;

	var buff=sResults.html();



	for(var i = 0 ; i < items.length;i++){
		var item = items[i];
		buff += "<a href='"+item.Url+"' class='search-result-item' target='_blank'>";
		buff += "<h3>"+item.Title+"</h3>";
		buff += "<p>"+item.Description+"</p>";

		buff += "</a>"
	}

	sResults.html(buff);



}


// WEBPACK FOOTER //
// ./BBZP/Frontend/js/modules/search.js